export default __webpack_public_path__ + "static/media/uploader-caresens-3.d8ed614d.png";